<template>
  <el-dialog
    :title="payMod=='integral'?'积分充值':'UM币兑换'"
    width="61.8%"
    custom-class="payDialog"
    :visible.sync="payDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    :before-close="handleClose"
    @close="close()"
  >
    <div v-if="payMod=='integral'">
      <div>请选择充值金额（当前余额：{{allAccount}}积分）</div>
      <ul class="paylist">
        <li
          @click="chooseNum(item.moneyNum,false)"
          :class="{'active':activeNum==item.moneyNum&&!otherNumChoose}"
          v-for="(item,index) in paylist"
          :key="index"
        >
          <div>
            <div class="jfNum">{{item.jfNum}} 积分</div>
            <div class="moneyNum">{{item.moneyNum}} 元</div>
          </div>
        </li>
        <li class="otherNum" @click="chooseNum(0,true)" :class="{'active':otherNumChoose}">
          <div>
            <div class="vCenter">
              <span>其他金额：</span>
              <input type="number" v-model="otherNum" ref="otherNum" @input="oninput" />元
            </div>
            <div class="moneyNum">{{accMul(otherNum,100)}} 积分</div>
          </div>
        </li>
      </ul>
      <ul class="clearfix paytypeList">
        <li :class="paytype==2?'payactive fl':'fl'" @click="qrcode();paytype=2">
          <img src="/img/payicon/wechat.png" alt />微信支付
        </li>
        <li :class="paytype==1?'payactive fl':'fl'" @click="paytype=1;alipayUrl()">
          <img src="/img/payicon/alipay.png" alt />支付宝支付
        </li>
      </ul>
      <div class="center qrcodeBox vCenter" v-if="paytype==2&&showcode">
        <button @click="qrcode()" class="creatcodeBtn">生成二维码</button>
      </div>
      <div class="center qrcodeBox vCenter" v-if="paytype==2&&!showcode">
        <div id="qrcode" ref="qrcode" class="qrcode"></div>
      </div>
      <div v-if="paytype==2" class="payTips">
        <img src="/img/payicon/wechat.png" alt />请使用微信支付完成付款
      </div>
    </div>
    <div v-if="payMod=='umcoin'">
      <div>请选择兑换数量（当前余额：{{umallAccount}}UM币）</div>
      <ul class="paylist">
        <li
          @click="chooseumNum(item.moneyNum,false)"
          :class="{'active':activeumNum==item.moneyNum&&!otherUmNumChoose}"
          v-for="(item,index) in umpaylist"
          :key="index"
        >
          <div>
            <div class="jfNum">{{item.umNum}} UM币</div>
            <div class="moneyNum">∮ {{item.moneyNum}}</div>
          </div>
        </li>
        <li class="otherNum" @click="chooseumNum(0,true)" :class="{'active':otherUmNumChoose}">
          <div>
            <div class="vCenter">
              <span>其他金额：</span>
              <input type="number" v-model="otherumNum" ref="otherNum" @input="onuminput" /> UM币
            </div>
            <div class="moneyNum">∮ {{accMul(otherumNum,100)}}</div>
          </div>
        </li>
      </ul>
      <div style="margin-bottom:20px">当前比率：1UMBit=100积分（100UMGrid）</div>
      <ul class="clearfix paytypeList">
        <li class="payactive fl">
          <img src="/img/payicon/jf.png" alt />积分兑换
        </li>
      </ul>
      <div class="center">
        <button @click="exchange()" class="exchange">立即兑换</button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
// import QRCode from "qrcodejs2";

export default {
  name: "umRecharge",
  data() {
    return {
      activeNum: 1,
      showcode: false,
      activeumNum: 100,
      allAccount: 0,
      umallAccount: 0,
      paylist: [
        {
          jfNum: 100,
          moneyNum: 1
        },
        {
          jfNum: 1000,
          moneyNum: 10
        },
        {
          jfNum: 5000,
          moneyNum: 50
        },
        {
          jfNum: 10000,
          moneyNum: 100
        }
      ],
      umpaylist: [
        {
          umNum: 1,
          moneyNum: 100
        },
        {
          umNum: 10,
          moneyNum: 1000
        },
        {
          umNum: 50,
          moneyNum: 5000
        },
        {
          umNum: 100,
          moneyNum: 10000
        }
      ],
      otherNum: 5,
      otherumNum: 5,
      otherNumChoose: false,
      paytype: 2,
      otherUmNumChoose: false
    };
  },
  mounted() {
    this.umaccount();
    this.account();
  },
  props: {
    payDialog: {
      type: Boolean,
      default: false
    },
    payMod: {
      type: String,
      default: "integral"
    }
  },
  watch: {
    payDialog(val) {
      if (val) {
        if (this.payMod == "integral") {
          this.qrcode();
        }
      }
    }
  },
  methods: {
    umaccount() {
      var that = this;
      $UMCore
        .post("route.lua", {
          data: JSON.stringify({
            functionname: "getchainaccount",
            umid: $UMCore.uncompile("umid")
          })
        })
        .then(res => {
          if (res.data.result) {
            var a = JSON.parse(res.data.data).result;
            // that.UMPayId = a.account_data.Account
            that.umallAccount = a.account_data.Balance / 1000000;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     * 获取总积分数
     */
    account() {
      $UMCore
        .post("/route.lua", {
          data: JSON.stringify({
            functionname: "integral_getintegralforumid",
            umid: $UMCore.uncompile("umid")
          })
        })
        .then(res => {
          this.allAccount = res.data.balance;
        })
        .catch(error => {
          this.$message.error("查询积分总数失败");
        });
    },
    accMul(arg1, arg2) {
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
    close() {
      this.$emit("close", false);
      this.payDialog = false;
    },
    /**
     * 生成二维码
     */
    qrcode() {
      console.log(this.activeNum);
      if (this.showcode) {
        this.activeNum = this.otherNum;
      }
      var link = "";
      $UMCore
        .post("https://open.umnet.cn/pay/index.php", {
          user_id: $UMCore.uncompile("umid"),
          money_value: this.activeNum,
          order_no: new Date().getTime()
        })
        .then(res => {
          console.log("res=", res.data.url);
          $("#qrcode").html("");
          this.showcode = false;
          this.$nextTick(() => {
            let qrcode = new QRCode("qrcode", {
              width: 160,
              height: 160,
              text: res.data.url, // 二维码地址
              colorDark: "#000",
              colorLight: "#fff"
            });
          });
        })
        .catch(error => {
          console.log("error=", error);
        });
    },
    alipayUrl() {
      if (this.showcode) {
        this.activeNum = this.otherNum;
      }
      window.open(
        "https://open.umnet.cn/pay/alipayzf.php?user_id=" +
          $UMCore.uncompile("umid") +
          "&money_value=" +
          this.activeNum +
          "&order_no=" +
          new Date().getTime()
      );
    },
    chooseNum(moneyNum, s) {
      this.otherNumChoose = s;
      if (!s) {
        this.activeNum = moneyNum;
        this.showcode = false;
        this.qrcode();
      } else {
        this.$refs.otherNum.focus();
        // $('.qrcodeBox').html('')
        this.showcode = true;
        // this.qrcode()
      }
    },
    chooseumNum(moneyNum, s) {
      this.otherUmNumChoose = s;
      this.paytype = 2;
      if (!s) {
        this.activeumNum = moneyNum;
      } else {
        this.$refs.otherNum.focus();
      }
    },
    oninput(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      this.otherNum = e.target.value;
    },
    onuminput(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      this.otherumNum = e.target.value;
    },
    exchange() {
      var integral = 0;
      if (this.otherUmNumChoose) {
        integral = this.otherumNum * 100;
      } else {
        integral = this.activeumNum;
      }
      var that = this;
      if (integral > that.umallAccount) {
        that.$message.error("兑换数量不能超过总数量！");
      } else {
        $UMCore
          .post("route.lua", {
            data: JSON.stringify({
              functionname: "integraltochainamount",
              umid: $UMCore.uncompile("umid"),
              integral: integral
            })
          })
          .then(res => {
            if (res.data.result) {
              this.$message({
                type: "success",
                message: "兑换成功！",
                onClose: () => {
                  this.payDialog = false;
                  this.umaccount();
                }
              });
            } else {
              this.$message.error("兑换失败，请重试！");
              return;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.paylist {
  margin-top: 20px;
  li {
    min-width: 110px;
    min-height: 90px;
    border: 1px solid #dedede;
    border-radius: 5px;
    margin: 0 10px 10px 0;
    display: inline-block;
    text-align: center;
    position: relative;
    cursor: pointer;
    padding: 0 10px;
    > div {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: calc(100% - 20px);
      .jfNum {
        font-size: 16px;
        font-weight: bold;
        color: rgba(46, 156, 241, 1);
        margin-bottom: 10px;
      }
      .moneyNum {
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  li.active {
    border: 1px solid rgba(46, 156, 241, 1);
  }
  .otherNum {
    width: 270px;
    color: rgba(153, 153, 153, 1);
    margin-right: 0;
    .vCenter {
      justify-content: center;
    }
    .moneyNum {
      margin-top: 10px;
    }
    input {
      border: 0;
      max-width: 70px;
      margin: 0 10px;
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
      border-bottom: 1px solid #ddd;
      text-align: center;
      padding: 3px;
    }
  }
}
.paytypeList {
  li {
    width: 200px;
    height: 70px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    text-align: center;
    line-height: 70px;
    font-size: 16px;
    margin-right: 10px;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
  }
  li.payactive {
    border: 1px solid rgba(46, 156, 241, 1);
  }
}
.payTips {
  text-align: center;
  margin-top: 10px;
  img {
    width: 16px;
    margin-right: 10px;
  }
}
.exchange {
  width: 200px;
  height: 40px;
  background: #2e9cf1;
  color: #fff;
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  margin-top: 40px;
}
.qrcodeBox {
  display: flex;
  justify-content: center;
  background: url("/img/wxcodebg.png") no-repeat;
  padding: 20px;
  width: 200px;
  height: 200px;
  margin: 20px auto 0;
  .creatcodeBtn {
    width: 200px;
    height: 40px;
    background: #22ac38;
    color: #fff;
    border-radius: 5px;
    border: 0;
    cursor: pointer;
  }
  .wxpaylogo {
    width: 160px;
    height: 37px;
  }
}
</style>


// WEBPACK FOOTER //
// src/packages/recharge/um-recharge.vue